/**
 * @generated SignedSource<<1458a2b0d5ae8d607a40dd58a7d8b825>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, GraphQLSubscription } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useWidgetTodoSubscriptionChangedSubscription$variables = {
  todoIds: ReadonlyArray<string>;
};
export type useWidgetTodoSubscriptionChangedSubscription$data = {
  readonly todoChangedByIds: {
    readonly id: string;
    readonly ordinal: string;
    readonly " $fragmentSpreads": FragmentRefs<"TodoOverviewListItemWidget_Todo">;
  };
};
export type useWidgetTodoSubscriptionChangedSubscription = {
  response: useWidgetTodoSubscriptionChangedSubscription$data;
  variables: useWidgetTodoSubscriptionChangedSubscription$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "todoIds"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "todoIds",
    "variableName": "todoIds"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "ordinal",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useWidgetTodoSubscriptionChangedSubscription",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Todo",
        "kind": "LinkedField",
        "name": "todoChangedByIds",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "TodoOverviewListItemWidget_Todo"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Subscription",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useWidgetTodoSubscriptionChangedSubscription",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Todo",
        "kind": "LinkedField",
        "name": "todoChangedByIds",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "status",
            "storageKey": null
          },
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "expireAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "TodoCategoryTag",
            "kind": "LinkedField",
            "name": "tags",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "color",
                "storageKey": null
              },
              (v4/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "assigneeText",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "TodoAssignedUser",
            "kind": "LinkedField",
            "name": "assignedUsers",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "name",
                    "storageKey": null
                  },
                  (v2/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "assignedAt",
                "storageKey": null
              },
              (v2/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdAt",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "9c1a3dc870af67384c5cf263affd5b8e",
    "id": null,
    "metadata": {},
    "name": "useWidgetTodoSubscriptionChangedSubscription",
    "operationKind": "subscription",
    "text": "subscription useWidgetTodoSubscriptionChangedSubscription(\n  $todoIds: [ID!]!\n) {\n  todoChangedByIds(todoIds: $todoIds) {\n    id\n    ordinal\n    ...TodoOverviewListItemWidget_Todo\n  }\n}\n\nfragment TodoCircleWidgetOverview_Todo on Todo {\n  expireAt\n  createdAt\n  status\n}\n\nfragment TodoOverviewListItemExpireInfo_Todo on Todo {\n  expireAt\n}\n\nfragment TodoOverviewListItemFooter_Todo on Todo {\n  tags {\n    id\n    color\n    title\n  }\n  assigneeText\n  assignedUsers {\n    user {\n      name\n      id\n    }\n    assignedAt\n    id\n  }\n}\n\nfragment TodoOverviewListItemWidget_Todo on Todo {\n  id\n  status\n  title\n  ...TodoOverviewListItemExpireInfo_Todo\n  ...TodoOverviewListItemFooter_Todo\n  ...TodoCircleWidgetOverview_Todo\n}\n"
  }
};
})();

(node as any).hash = "611e30ffb5cf4af74d30fb3f05273950";

export default node;
